import {MoreMenu} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {MoreMenuProps} from '@sollapay/ui/components';
import type {FC} from 'react';

export type PaymentInstructionMenuAction = 'resend' | 'cancel' | 'unmarkHandled';

export interface PaymentInstructionMoreMenuProps {
  actions: PaymentInstructionMenuAction[];
  onResend?: () => void;
  onCancel?: () => void;
  onUnmarkHandled?: () => void;
  orientation?: MoreMenuProps['orientation'];
}

export const PaymentInstructionMoreMenu: FC<PaymentInstructionMoreMenuProps> = ({
  actions,
  onResend,
  onCancel,
  onUnmarkHandled,
  orientation
}) => {
  const {t} = useTranslation('trustAccounts');

  const actionConfig: Record<PaymentInstructionMenuAction, MoreMenuProps['items'][number]> = {
    resend: {
      icon: 'credit-card-refresh',
      label: t('view.buyers.detail.tableActions.resend'),
      onClick: () => onResend?.()
    },
    cancel: {
      icon: 'credit-card-cancel',
      label: t('view.buyers.detail.tableActions.cancel'),
      onClick: () => onCancel?.(),
      destructive: true,
      separator: true
    },
    unmarkHandled: {
      icon: 'refresh',
      label: t('view.buyers.detail.tableActions.unmarkHandled'),
      onClick: () => onUnmarkHandled?.()
    }
  };

  const handlerMap: Record<PaymentInstructionMenuAction, (() => void) | undefined> = {
    resend: onResend,
    cancel: onCancel,
    unmarkHandled: onUnmarkHandled
  };

  const items = actions.filter(action => !!handlerMap[action]).map(action => actionConfig[action]);

  return (
    <MoreMenu
      ariaLabel={t('view.buyers.detail.tableActions.openMenu')}
      orientation={orientation}
      items={items}
    />
  );
};
